import { Component } from 'preact'
import InputGroup from '../../control-components/ui-components/InputGroup'
import { StylingConfigType } from './configurator'
import Button from '@insided/control/uikit/Button'

interface Props {
  defaultStyling: StylingConfigType
  updatedStyling: StylingConfigType
  onUpdate: (config: StylingConfigType) => void
}

export default class Fonts extends Component<Props> {
  updateStyling(key: string, value: string) {
    this.props.onUpdate({ ...this.props.updatedStyling, ...{ [key]: value } })
  }

  render() {
    const { defaultStyling, updatedStyling, onUpdate } = this.props
    return (
      <div className='box__pad'>
        <ul className='theme-configuration_colors-list'>
          <li className='theme-configuration_colors-list-item body-font'>
            <strong>Body font</strong>
            <p>Define the body font used for paragraphs</p>
            <InputGroup
              type='text'
              value={updatedStyling['config--main-font-base-stack'] || ''}
              onKeyUp={(event) => {
                const { value } = event.target
                return this.updateStyling('config--main-font-base-stack', value)
              }}
            />
          </li>

          <li className='theme-configuration_colors-list-item heading-font'>
            <strong>Heading font</strong>
            <p>Define the heading font used for headers and titles</p>
            <InputGroup
              type='text'
              value={updatedStyling['config--main-font-secondary'] || ''}
              onKeyUp={(event) => {
                const { value } = event.target
                return this.updateStyling('config--main-font-secondary', value)
              }}
            />
          </li>

          <li className='theme-configuration_colors-list-item button-font'>
            <strong>Button font</strong>
            <p>Define the button font used for buttons</p>
            <InputGroup
              type='text'
              value={updatedStyling['config--main-button-base-font-family'] || ''}
              onKeyUp={(event) => {
                const { value } = event.target
                this.updateStyling('config--main-button-base-font-family', value)
              }}
            />
          </li>
        </ul>

        <Button variant='warning' onClick={() => onUpdate(defaultStyling)}>
          Reset to defaults
        </Button>
      </div>
    )
  }
}
